goog.provide("shadow.js.shim.module$src$svg$inform$lightbulb_coil_svg$default");
shadow.js.shim.module$src$svg$inform$lightbulb_coil_svg$default = shadow.js.shim.module$src$svg$inform$lightbulb_coil_svg.default;
